let stripePromise: Promise<any> | null = null;

export function loadStripeJs(): Promise<any> {
  if (typeof window === 'undefined') {
    return Promise.reject(new Error('Stripe.js cannot be loaded in a non-browser context.'));
  }

  const existingStripe = (window as any).Stripe;
  if (existingStripe) {
    return Promise.resolve(existingStripe);
  }

  if (stripePromise) {
    return stripePromise;
  }

  stripePromise = new Promise((resolve, reject) => {
    const scriptId = 'stripe-js';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://js.stripe.com/v3';
      script.async = true;
      script.onload = () => resolve((window as any).Stripe);
      script.onerror = () => reject(new Error('Stripe.js failed to load.'));
      document.head.appendChild(script);
      return;
    }

    script.addEventListener('load', () => resolve((window as any).Stripe));
    script.addEventListener('error', () => reject(new Error('Stripe.js failed to load.')));
  });

  return stripePromise;
}
